import axios from "axios";
import Constants from "@/constants";

class NeedsService {
  constructor() {
    this.table_name = "realestate.client_needs";
  }

  async listAllByClient(clientId) {
    var query = `SELECT * FROM ${this.table_name} WHERE client_id='${clientId}' ORDER BY created_at DESC`;

    query = encodeURI(query);
    var url = Constants.HOST_URL + "runSelectQuery?query=" + query;

    try {
      var response = await axios.get(url);
      console.log(response.data);

      return response.data;
    } catch (err) {
      alert(err);
    }
  }

  async submitNeed(columns, values) {
    var query = `INSERT INTO ${this.table_name} (`;
    query += columns.join(",");
    query += ") VALUES (";
    query += values.join(",");
    query += ");";

    var url = Constants.HOST_URL + "runInsertQuery?query=" + query;

    try {
      var response = await axios.get(url);
      console.log(response.data);

      this.id = response.data.insertId;
      return response.data;
    } catch (e) {
      alert(e);
    }
  }

  async updateNeed(id, columns, values) {
    var query = `UPDATE ${this.table_name} SET `;

    const numberItems = columns.length;

    for (let i = 0; i < numberItems; i++) {
      query += columns[i] + "=" + values[i];
      if (i < numberItems - 1) query += ", ";
    }

    query += " WHERE id=" + id;

    var url = Constants.HOST_URL + "runUpdateQuery?query=" + query;

    var response = await axios.get(url);
    if (!response.data) {
      alert("Lỗi khi cập nhật Nhu cầu.");
      return;
    }

    console.log(response.data[0]);
    return response.data[0];
  }

  async updateNeedOnClientTable(clientId, columns, values) {
    var query = `UPDATE realestate.clients SET `;

    const numberItems = columns.length;

    for (let i = 0; i < numberItems; i++) {
      if (columns[i] != "client_id" && columns[i] != "needs_group") {
        query += columns[i] + "=" + values[i];
        if (i < numberItems - 1) query += ", ";
      }
    }

    query += " WHERE id=" + clientId;

    var url = Constants.HOST_URL + "runUpdateQuery?query=" + query;

    var response = await axios.get(url);
    if (!response.data) {
      alert("Lỗi khi cập nhật Nhu cầu ở bảng Khách hàng");
      return;
    }

    console.log(response.data[0]);
    return response.data[0];
  }

  async remove(id) {
    var query = `DELETE FROM ${this.table_name} WHERE id =${id}`;

    var url = Constants.HOST_URL + "runDeleteQuery?query=" + query;

    try {
      var response = await axios.get(url);
      console.log(response.data);
    } catch (e) {
      alert(e);
    }
  }

  async deleteNeedByClientId(clientId) {
    var query = `DELETE FROM ${this.table_name} WHERE client_id =${clientId}`;

    var url = Constants.HOST_URL + "runDeleteQuery?query=" + query;

    try {
      var response = await axios.get(url);
      console.log(response.data);
    } catch (e) {
      alert(e);
    }
  }
}

export default NeedsService;
